
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/yangiliklar",
      function () {
        return require("private-next-pages/yangiliklar/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/yangiliklar"])
      });
    }
  